<div class="css-Item_correo-2 item_correo">
    <div class="css-Texto_correo-2 texto_correo">
        <p class="css-Correo-2 correo">{{correo}}</p>
    </div>
    <div class="css-Icono_Cerrar icono_cerrar" (click)="eliminar()">
        <img src="assets/images/basecomponents-images/item-correo.svg" width="10px" height="10px"
            class="css-Vector_close vector_close">
    </div>
</div>